<template>
  <div class="containerTore" id="appTore">

      <img v-bind:class="{smallImg: fooSmallImg}" class="badgeImg" v-bind:src="'public/white/badge_000'+ fooBadge +'_Vektor-Smartobjekt.png'">

  </div>
</template>
<script>

export default {
  data () {
    return {
      intervalid1:'',

    }
  },
  props: ['fooBadge', 'fooSmallImg'],
  timers: {

  },
  methods: {
    }
  }


</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Badges.vue